import React from 'react'

export default function Footer() {
  return (
    <div>
        <div className="w-full bg-zinc-800 grid grid-cols-4" style={{height: "157px"}}>
            
        </div>
      <div className='w-full bg-neutral-300' style={{height: "472px"}}>

      </div>
    </div>
  )
}
